












import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-price'
})

export default class extends Vue {
  private get totalPrices(): object {
    return this.$store.getters['CatalogProduct/totalPrices'] || {};
  }

  private get locale(): string {
    return this.$config.get('locale');
  }

  private mounted(): void {
    const placeholder = document.getElementById(`pricePlaceholder`);
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }
}
